/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2023-06-28 11:18:54
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\components_data\dataCompletion.js
 */
/*
 * @Author: your name
 * @Date: 2021-01-12 12:08:10
 * @LastEditTime: 2021-01-15 10:53:34
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /icps_baseWeb/src/api/smart/components_data/dataCompletion.js
 */
import request from "@/utils/request";
export const queryPage = "/icps/system/sign/basics/handOverInformation/queryPage";
export const Download = ''
/*导出资料*/
export const exportHandOver = "/icps/system/sign/basics/handOverInformation/exportHandOver";
/*修改交工资料*/
export function updateResod(data) {
  return request({
    url: "/icps/system/sign/basics/handOverInformation/updateResod",
    method: "post",
    data,
  });
}
/*删除订单*/
export function deleteResord(data) {
  return request({
    url: "/icps/system/sign/intelligent/handOverPlan/deleteResord",
    method: "post",
    data,
  });
}

/*用于预览查询地址*/
export function previewHandOver(data) {
  return request({
    url: "/icps/system/sign/basics/handOverInformation/previewHandOver",
    method: "post",
    data,
  });
}
/*报告未配置*/
export function selectMixProportionDetails(data) {
  return request({
    url: "/icps/system/sign/basics/handOverInformation/selectMixProportionDetails",
    method: "post",
    data,
  });
}
/*报告未配置 混凝土*/
export function selectMixProportionDetailsThree(data) {
  return request({
    url: "/icps/system/sign/basics/handOverInformation/selectMixProportionDetailsThree",
    method: "post",
    data,
  });
}
/*报告已配置*/
export function selectMixProportionReportDetail(data) {
  return request({
    url: "/icps/system/sign/basics/handOverInformation/selectMixProportionReportDetail",
    method: "post",
    data,
  });
}
/*报告已配置*/
export function saveMixProportionDetails(data) {
  return request({
    url: "/icps/system/sign/basics/handOverInformation/saveMixProportionDetails",
    method: "post",
    data,
  });
}
/*查询抗压抗渗报告*/
export function selectReportList(data) {
  return request({
    url: "/icps/system/sign/basics/handOverInformation/selectReportList",
    method: "post",
    data,
  });
}
/*查询配合比*/
export function selectMixProportion(data) {
  return request({
    url: "/icps/system/sign/basics/handOverInformation/selectMixProportion",
    method: "post",
    data,
  });
}
/*查询配合比*/
export function deleteHandOverReport(data) {
  return request({
    url: "/icps/system/sign/basics/handOverInformation//deleteHandOverReport",
    method: "post",
    data,
  });
}
/*抗压抗渗报告修改 */
export function updateReportDetailsList(data) {
  return request({
    url: "/icps/system/sign/basics/handOverInformation/updateReportDetailsList",
    method: "post",
    data,
  });
}
/*抗压抗渗报告修改详情查询 */
export function selectReportDetailsList(data) {
  return request({
    url: "/icps/system/sign/basics/handOverInformation/selectReportDetailsList",
    method: "post",
    data,
  });
}
/*配合比报告保存 */
export function saveOrUpdatePlan(data) {
  return request({
    url: "/icps/system/sign/basics/handOverInformation/saveOrUpdatePlan",
    method: "post",
    data,
  });
}
/*配合比报告保存 */
export function saveOrUpdatePlanList(data) {
  return request({
    url: "/icps/system/sign/basics/handOverInformation//saveOrUpdatePlanList",
    method: "post",
    data,
  });
}
